module.exports = __webpack_public_path__ + "static/media/no-cowboy.4f161211.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pic-collage/no-cowboy.jpg
// module id = 204
// module chunks = 0